import { Entity } from '@toggle/toggle';
import React from 'react';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { BrandsAndProducts } from '~/modules/overview-knowledge-graph/components/brands-and-products/BrandsAndProducts';
import { CompetitorsKnowledgeGraph } from '~/modules/overview-knowledge-graph/components/competitors-knowledge-graph/CompetitorsKnowledgeGraph';
import { GeographicExposureKnowledgeGraph } from '~/modules/overview-knowledge-graph/components/geographic-exposure-knowledge-graph/GeographicExposureKnowledgeGraph';
import { ThemeKnowledgeGraph } from '~/modules/overview-knowledge-graph/components/theme-knowledge-graph/ThemeKnowledgeGraph';

import { RankingMethodologySection } from '../theme-exposure-tab/theme-exposure-table/ranking-methodology-section/RankingMethodologySection';
import * as S from './OverviewTab.styles';

export interface OverviewTabProps {
  entity: Entity;
  hasThemeData?: boolean;
  hasBrandsAndProductsData?: boolean;
  hasCompetitorsData?: boolean;
  hasGeographicData?: boolean;
}

export const OverviewTab = ({
  entity,
  hasThemeData = true,
  hasBrandsAndProductsData = false,
  hasCompetitorsData = true,
  hasGeographicData = true,
}: OverviewTabProps) => {
  return (
    <div>
      <S.GridContainer>
        {hasThemeData && (
          <ErrorBoundaryWrapper>
            <S.StyledThemeKnowledgeGraph>
              <ThemeKnowledgeGraph entityTag={entity.tag} isInDrawer={false} />
            </S.StyledThemeKnowledgeGraph>
          </ErrorBoundaryWrapper>
        )}
        {hasBrandsAndProductsData && (
          <ErrorBoundaryWrapper>
            <S.StyledBrandsAndProducts>
              <BrandsAndProducts entity={entity} />
            </S.StyledBrandsAndProducts>
          </ErrorBoundaryWrapper>
        )}
        {hasCompetitorsData && (
          <ErrorBoundaryWrapper>
            <S.StyledCompetitorsKnowledgeGraph>
              <CompetitorsKnowledgeGraph
                entityTag={entity.tag}
                isInDrawer={false}
              />
            </S.StyledCompetitorsKnowledgeGraph>
          </ErrorBoundaryWrapper>
        )}
        {hasGeographicData && (
          <ErrorBoundaryWrapper>
            <S.StyledGeographicExposureKnowledgeGraph>
              <GeographicExposureKnowledgeGraph entity={entity} />
            </S.StyledGeographicExposureKnowledgeGraph>
          </ErrorBoundaryWrapper>
        )}
      </S.GridContainer>
      <RankingMethodologySection rankingType={'companyToTheme'} />
    </div>
  );
};
